<template lang="pug">
v-container( fluid class="tw-p-0 tw-h-full")
    v-row(no-gutters class="tw-h-full ")
        v-col(cols="7" class="tw-h-full")
            kubiqa-contacts-relate-create-contact(:entityType="entityType")
        v-col(cols="5" class="tw-h-full tw-max-h-full")
            kubiqa-contacts-relate-list(:entityType="entityType")
</template>
<script>
export default {
    props:{
        entityType: {
            type: String,
            default: null
        }
    }
}
</script>